import React from "react";
import ss from "./Avatar.module.css";
import classNames from "classnames";

export default function Avatar(props) {
  const { num, active, selectTeam, width, style } = props;

  return (
    <div
      style={{
        width: `${width}rem`,
        height: `${width}rem`,
        ...style,
      }}
      className={classNames(ss.avatar)}
      onClick={() => {
        if (selectTeam) {
          selectTeam(num);
        }
      }}
    >
      <img src={require(`./img/color${num}.png`)} alt="" />
      <div
        style={{
          width: `${width}rem`,
          height: `${width}rem`,
        }}
        className={classNames(active && ss.active)}
      ></div>
    </div>
  );
}
